module.exports = __webpack_public_path__ + "483c1317a29c8ae2ac9a30533ed92dc0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gilles-harmonica-s.png
// module id = 2042
// module chunks = 0